import Utils from '@/utils/utils'

const component = () => import('../pages/seckill/seckill-detail.vue')
const routerPath = [
  "/seckillDetailfour",
  "/seckillDetailfive",
  "/seckillDetailsix",
  "/seckillDetailseven",
  "/seckillDetaileight",
  "/seckillDetailnine",
  "/seckillDetailten",
  "/seckillDetaileleven",
  "/seckillDetailtwelve",
  "/seckillDetailthirteen",
  "/seckillDetailfourteen",
  "/seckillDetailfifteen",
  "/seckillDetailsixteen",
  "/seckillDetailseventeen",
  "/seckillDetaileighteen",
  "/seckillDetailnineteen",
  "/seckillDetailtwenty",
  "/seckillDetailbase",
  "/seckillDetaila",
  "/seckillDetailb",
  "/seckillDetailc",
  "/seckillDetaild",
  "/seckillDetaile",
  "/seckillDetailf",
  "/seckillDetailg",
  "/seckillDetailh",
  "/seckillDetaili",
  "/seckillDetailj",
  "/seckillDetailk",
]

const routerList = routerPath.map((path) => {
  return Utils.createRouterItem({
    path,
    meta: {
      title: '秒杀详情'
    },
    component,
  })
})
export default routerList
